export enum Position {
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right',
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}

export type PositionStrict = Position.Top | Position.Bottom | Position.Left | Position.Right;
